import React from "react";

import cx from "classnames";

export type CardFooterProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const CardFooter: React.FC<React.PropsWithChildren<Readonly<CardFooterProps>>> = ({
  className,
  children,
  ...props
}) => (
  <div {...props} className={cx("border-t border-gray-200 bg-gray-50 px-4 py-4 sm:px-6", className)}>
    {children}
  </div>
);
